import actionTypes from '../constants/action-types';
import deviceModes from '../constants/device-modes';

const deviceMode = (state = deviceModes.DESKTOP, action) => {
  if (action.type !== actionTypes.SET_DEVICE_MODE) return state;

  return action.payload.deviceMode;
};

export default deviceMode;
